import usePush from './usePush';

const usePushHome = () => {
  const pushPath = usePush();

  const pushHome = () => {
    pushPath('/');
  };

  return pushHome;
};

export default usePushHome;
